import { Maybe } from '_app/types/api'

export const dropMaybe = <T>(thing: Maybe<T> | undefined): T | undefined =>
  thing || undefined
